import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/nav";

import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import Introduction from "@/sections/Introduction";
import Services from "@/sections/Services";
import HowWeWork from "@/sections/HowWeWork";
import OciEngage from "@/sections/OciEngage";
import WhyAmanah from "@/sections/WhyAmanah";
import About from "@/sections/About";
import Standards from "@/sections/Standards";
import ClosingCTA from "@/sections/ClosingCTA";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  const { state, hash } = useLocation();

  usePageMeta(
    "Amanah Promotions | Ethical Fundraising. Measurable Impact.",
    "Amanah Promotions helps charities acquire committed regular donors through professional, ethical face-to-face fundraising and clear campaign oversight across England and Wales."
  );

  useEffect(() => {
    const target = state?.scrollTo || (hash ? hash.replace("#", "") : null);
    if (!target) return;
    // Retry scrolling as route-mounted content, fonts and images settle so
    // Lenis lands on the final geometry rather than a stale coordinate.
    let tries = 0;
    let timer;
    const attempt = () => {
      const el = document.getElementById(target);
      if (el) {
        scrollToId(target);
        tries += 1;
        if (tries < 5) timer = setTimeout(attempt, 220);
      } else if (tries < 15) {
        tries += 1;
        timer = setTimeout(attempt, 120);
      }
    };
    timer = setTimeout(attempt, 100);
    return () => clearTimeout(timer);
  }, [state, hash]);

  return (
    <>
      <Hero />
      <Marquee />
      <Introduction />
      <Services />
      <HowWeWork />
      <OciEngage />
      <WhyAmanah />
      <About />
      <Standards />
      <ClosingCTA />
    </>
  );
}
